import React, {
	useEffect,
	useCallback,
	useState
} from 'react';
import PropTypes from 'prop-types';
import {
	Prompt,
	useHistory
} from 'react-router-dom';

import {
	useUIState,
	useUIAction
} from '../../../contexts/UIContext';

import Alert from '../../Alert';

const UnlockNavConfirm = () => {
	const history = useHistory();

	const {
		navLock,
		unlockNavConfirm
	} = useUIState();
	const {
		setNavLock,
		setUnlockNavConfirm
	} = useUIAction();

	const [ path, setPath ] = useState();
	const [ confirmNavigation, setConfirmNavigation ] = useState( false );

	const handleClose = useCallback( () => {
		setUnlockNavConfirm( false );
	}, [ setUnlockNavConfirm ] );

	const handleBlockedNavigation = useCallback( location => {
		if ( navLock ) {
			setUnlockNavConfirm( true );
			setPath( location.pathname );

			return false;
		}

		return true;
	}, [
		navLock,
		setUnlockNavConfirm
	] );

	const handleConfirmNavigation = useCallback( () => {
		setUnlockNavConfirm( false );
		setNavLock( false );
		setConfirmNavigation( true );
	}, [
		setNavLock,
		setUnlockNavConfirm
	] );

	useEffect( () => {
		if ( confirmNavigation ) {
			history.push( path );
		}

		return () => {
			setConfirmNavigation( false );
		};
	}, [
		confirmNavigation,
		history,
		path
	] );

	return (
		<>
			<Prompt
				when={ navLock }
				message={ handleBlockedNavigation }
			/>
			<Alert
				action={ handleConfirmNavigation }
				actionText="Yes, continue"
				heading="Unsaved Progress"
				name="contact-unsaved-progress-confirm-alert"
				message="Are you sure? Any unsaved progress will be lost."
				open={ unlockNavConfirm }
				closeModal={ handleClose }
				closeText="Go back"
				type="warning"
			/>
		</>
	);
};

UnlockNavConfirm.propTypes = { shouldBlockNavigation: PropTypes.bool };

export default UnlockNavConfirm;
